// src/config/blockThemes.js
const blockThemes = [
  {
    style: {
      '--theme-color': 'white',
      '--theme-high-contrast-color': 'var(--blue)',
      '--theme-header-color': 'var(--blue)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--blue)',
      '--link-foreground-color': 'var(--blue)',
    },
    name: 'default',
    label: 'Default',
  },
  {
    style: {
      '--theme-color': 'var(--lightgrey)',
      '--theme-high-contrast-color': 'var(--charcoal)',
      '--theme-header-color': 'var(--blue)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--grey)',
      '--link-foreground-color': 'var(--charcoal)',
    },
    name: 'lightgrey',
    label: 'Light Grey',
  },
  {
    style: {
      '--theme-color': 'var(--lightblue)',
      '--theme-high-contrast-color': 'var(--charcoal)',
      '--theme-header-color': 'var(--blue)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--charcoal)',
      '--link-foreground-color': 'var(--charcoal)',
    },
    name: 'lightblue',
    label: 'Light Blue',
  },
  {
    style: {
      '--theme-color': 'var(--blue)',
      '--theme-high-contrast-color': 'white',
      '--theme-header-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'blue',
    label: 'Blue',
  },
  {
    style: {
      '--theme-color': 'var(--darkblue)',
      '--theme-high-contrast-color': 'white',
      '--theme-header-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'darkblue',
    label: 'Dark Blue',
  },
  {
    style: {
      '--theme-color': 'var(--yellow)',
      '--theme-high-contrast-color': 'white',
      '--theme-header-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'yellow',
    label: 'Yellow',
  },
  {
    style: {
      '--theme-color': 'var(--charcoal)',
      '--theme-high-contrast-color': 'white',
      '--theme-header-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'charcoal',
    label: 'Charcoal',
  },
];

export default blockThemes;
